import { defineMessages } from 'react-intl';

export default {
  pages: {
    landing: {
      videoDreamsBanner: {
        livejasmin: {
          ...defineMessages({
            title: {
              id: 'pages.landing.videoDreamsBanner.livejasmin.title',
              defaultMessage: 'Turn your dreams into reality!',
            },
            join: {
              id: 'pages.landing.videoDreamsBanner.livejasmin.join',
              defaultMessage:
                'Join the no. {num} premium cam platform in the world and start earning anytime, anywhere!',
            },
            signUp: {
              id: 'pages.landing.videoDreamsBanner.livejasmin.signUp',
              defaultMessage: 'Join now',
            },
          }),
          rotation: defineMessages({
            yourTime: {
              id: 'pages.landing.videoDreamsBanner.livejasmin.rotation.yourTime',
              defaultMessage: 'Your time.',
            },
            yourMoney: {
              id: 'pages.landing.videoDreamsBanner.livejasmin.rotation.yourMoney',
              defaultMessage: 'Your money.',
            },
            yourRules: {
              id: 'pages.landing.videoDreamsBanner.livejasmin.rotation.yourRules',
              defaultMessage: 'Your rules.',
            },
          }),
        },
      },
    },
  },
};
